import {cardBalanceSlice} from './cardBalance/index';
import {combineReducers} from 'redux';
import {cardSlice} from './card';
import {cardPaymentHistorySlice} from './cardPaymentsHistory';
import {cardInfoNewSlice} from './cardInfoNew';

export const transportCard = combineReducers({
  card: cardSlice.reducer,
  cardBalance: cardBalanceSlice.reducer,
  cardPaymentHistory: cardPaymentHistorySlice.reducer,
  cardInfoNew: cardInfoNewSlice.reducer,
});

export type TransportCardState = ReturnType<typeof transportCard>;
